import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import PureRenderMixin from 'react-pure-render/mixin';
import ConfirmActions from 'flux/actions/ConfirmActions';
import DownloadHelper from 'shared/lib/downloadHelper';
import UserActions from 'shared/flux/actions/UserActions';
import role from 'shared/lib/role';

const menuId = 'proofColumnMenu';

export default React.createClass({
  displayName: 'ProofColumnMenu',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(CuesheetStore, 'proofOfPerformanceTracking', (state) =>
      state.getIn(['show', 'proofOfPerformanceTracking']),
    ),
    Reflux.connect(UserSessionStore, 'user'),
    PureRenderMixin,
    ColumnMenuMixin,
  ],

  render() {
    const showMenu = this.state.popoverVisibility.get(menuId);

    return (
      <PopoverMenu
        className="cs-proof-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    return Map({
      id: menuId,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(menuId),
      onHide: () => PopoverActions.hide(menuId),
      items: this._getItemData(),
    });
  },

  _getItemData() {
    const { params } = this.context.router.state;

    const { proofOfPerformanceTracking } = this.state;
    const { teamId, eventId } = this.context.router.state.params;

    const hasEventAdmin = role.hasEventAdminRole(
      this.state.user,
      teamId,
      eventId,
    );

    return OrderedMap({
      hide: Map({
        content: 'Hide Timestamp Column',
        onClick: () => this._handleHideProofClick(),
      }),
      clearVisible: Map({
        hidden: !hasEventAdmin,
        content: 'Clear all visible timestamps',
        onClick: () => this._handleClearTimestamps(),
      }),
      enableTrackingTimestamp: Map({
        hidden: !hasEventAdmin || proofOfPerformanceTracking,
        content: 'Enable auto-timestamp via tracking',
        onClick: () => {
          CuesheetColumnActions.enableProofTracking();
        },
      }),
      disableTrackingTimestamp: Map({
        hidden: !hasEventAdmin || proofOfPerformanceTracking === false,
        content: 'Disable auto-timestamp via tracking',
        onClick: () => {
          CuesheetColumnActions.disableProofTracking();
        },
      }),
      export: Map({
        hidden: !hasEventAdmin,
        content: 'Export timestamp show report',
        onClick: () => {
          DownloadHelper.downloadTimestampsXLS(params);
        },
      }),
      exportWithHistory: Map({
        hidden: !hasEventAdmin,
        content: 'Export timestamp show report with history',
        onClick: () => {
          DownloadHelper.downloadTimestampsXLS(params, { withHistory: 'true' });
        },
      }),
    }).filter((item) => item.get('hidden') !== true);
  },

  _handleHideProofClick() {
    UserActions.updatePreference(
      this.state.user.get('_id'),
      'displayProofOfPerformance',
      false,
    );
  },

  _handleClearTimestamps() {
    ConfirmActions.prompt(
      <div>
        This will remove <strong>all</strong> visible timestamps from your show!
      </div>,
      () => CuesheetColumnActions.clearProofOfPerformance(),
    );
  },
});
